
import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/62bfd8064e11f74310ce1cc00b80d48a/15008d0ff6d4e279e16823007d480805.jpeg')`
      }}
    >
      <div className="container mx-auto px-6 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            건설 현장의 <span className="text-blue-400">스마트한 미래</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
            통합자동화 계측 시스템으로 건설 현장의 안전성과 효율성을 극대화하세요. 
            실시간 모니터링과 AI 분석으로 프로젝트 성공을 보장합니다.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button variant="primary" size="lg" className="bg-blue-600 hover:bg-blue-700">
              <i className="ri-play-circle-line mr-2"></i>
              시스템 데모 보기
            </Button>
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-gray-900">
              <i className="ri-download-line mr-2"></i>
              자료 다운로드
            </Button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">안전 보장</h3>
              <p className="text-gray-200">실시간 위험 감지 및 예방 시스템</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">효율성 증대</h3>
              <p className="text-gray-200">AI 기반 데이터 분석 및 최적화</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">실시간 모니터링</h3>
              <p className="text-gray-200">24/7 연속 계측 및 알림 시스템</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
